module.exports = __webpack_public_path__ + "img/photovoltaicStorageEMS.6e44f619.svg";